import ClientApplication from 'api/application/interfaces/ClientApplication'
import { fetchJson } from 'api/fetcher'
import useSwr from 'swr'

export const getClientApplicationSwrKey = (
    applicationId: string | undefined,
) => (applicationId ? `v3/client-application/${applicationId}/` : null)

export interface UseClientApplicationInterface {
    clientApplication: ClientApplication | undefined
    loading: boolean
    error: Error | null
}

const useClientApplication = (
    applicationId: string | undefined,
): UseClientApplicationInterface => {
    const {
        data: clientApplication,
        error,
        isLoading,
    } = useSwr(
        getClientApplicationSwrKey(applicationId),
        fetchJson<ClientApplication>,
        {
            errorRetryCount: 0,
        },
    )

    return {
        clientApplication,
        loading: isLoading,
        error,
    }
}

export default useClientApplication
